import { motion } from "framer-motion";
import { Search } from "lucide-react";

export default function SearchBar({ onSearch }) {
  return (
    <motion.form
      onSubmit={(e) => {
        e.preventDefault();
        const form = e.currentTarget;
        const value = new FormData(form).get("q");
        onSearch?.(String(value || ""));
      }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="flex gap-2 items-center mx-auto w-full max-w-xl"
    >
      <div className="flex gap-2 items-center px-3 w-full h-11 bg-white rounded-lg border shadow-sm border-emerald-600/30">
        <Search size={16} className="text-gray-500" />
        <input
          name="q"
          placeholder="Ask a Question.."
          className="flex-1 h-full text-sm bg-transparent focus:outline-none placeholder:text-gray-400"
        />
      </div>
      <button
        type="submit"
        className="px-4 h-11 text-sm font-semibold text-white bg-emerald-600 rounded-lg hover:bg-emerald-700"
      >
        Search
      </button>
    </motion.form>
  );
}


